module.exports = __webpack_public_path__ + "static/media/facebook-icon.b1022090.svg";